export function checkValidation(vueComponent) {
  //check***Valid 인 computed 전부 확인
  for (const elm in vueComponent._computedWatchers) {
    const elmName = elm;
    if (elmName.startsWith("check") &&
        elmName.endsWith("Valid")) {
      if (!vueComponent._computedWatchers[elm].value) {
        return false;
      }
    }
  }
  return true;
}
